import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=0bb170bf&scoped=true"
import script from "./designer.vue?vue&type=script&lang=js"
export * from "./designer.vue?vue&type=script&lang=js"
import style0 from "./designer.vue?vue&type=style&index=0&id=0bb170bf&prod&lang=scss&scoped=true"
import style1 from "./designer.vue?vue&type=style&index=1&id=0bb170bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb170bf",
  null
  
)

export default component.exports